export default "__VITE_ASSET__CfA2H96A__"